import { useMutation } from '@apollo/client';
import { Button, Form, Input, Space } from 'antd';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { MAX_LENGTHS } from '../../../common/constants';
import { formValidatorRules } from '../../../common/utils';
import { Permissions } from '../../pages/component/pageModules/moduleForms/FormInputs';
import { useEditPage } from '../../pages/context/EditPageProvider';
import { UPDATE_PAGE_TEMPLATE } from '../graphql/Mutations';

const TemplateSettings = () => {
  const {
    setSelectionType,
    settings,
    fetchingPageDetails,
    refetchPageDetails
  } = useEditPage();
  const [form] = Form.useForm();
  const { id } = useParams();

  useEffect(() => {
    form.setFieldsValue({
      ...settings,
      permissions: settings?.permissions?.map((value) => ({
        label: value,
        value
      }))
    });
  }, [settings, form]);

  const [updateTemplate, { loading }] = useMutation(UPDATE_PAGE_TEMPLATE, {
    onError: () => {}
  });

  const handleSubmit = ({ permissions, ...values }) => {
    updateTemplate({
      variables: {
        where: { id },
        data: {
          ...values,
          permissions: permissions?.map(({ value }) => value) ?? []
        }
      }
    }).then(() => {
      setSelectionType('');
      refetchPageDetails();
    });
  };

  const handleCancel = () => {
    setSelectionType('');
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={settings}
      disabled={fetchingPageDetails}
    >
      <Form.Item
        label="Title"
        name="title"
        required
        rules={[
          formValidatorRules?.required('Please enter title!'),
          formValidatorRules?.maxLength(MAX_LENGTHS.TITLE)
        ]}
      >
        <Input placeholder="Enter title" disabled readOnly />
      </Form.Item>

      <Form.Item
        name="templateName"
        label="Template Name"
        required
        rules={[
          formValidatorRules?.required('Please enter template name!'),
          formValidatorRules?.maxLength(MAX_LENGTHS.TITLE)
        ]}
      >
        <Input placeholder="Enter template name" />
      </Form.Item>

      <Form.Item
        label="Description"
        name="description"
        rules={[formValidatorRules?.maxLength(MAX_LENGTHS.DESCRIPTION)]}
      >
        <Input.TextArea placeholder="Enter description" />
      </Form.Item>

      <Form.Item label="Meta Image" name="metaImage">
        <Input placeholder="Enter image url" />
      </Form.Item>

      <Form.Item
        name="metaHeader"
        label="Meta Header"
        rules={[formValidatorRules?.maxLength(MAX_LENGTHS.DESCRIPTION)]}
      >
        <Input.TextArea rows={5} placeholder="Enter meta header" />
      </Form.Item>

      <Form.Item
        name="metaFooter"
        label="Meta Footer"
        rules={[formValidatorRules?.maxLength(MAX_LENGTHS.DESCRIPTION)]}
      >
        <Input.TextArea rows={5} placeholder="Enter meta footer" />
      </Form.Item>

      <Permissions />

      <div className="d-flex button-section">
        <Space>
          <Form.Item>
            <Button
              disabled={fetchingPageDetails || loading}
              loading={loading}
              htmlType="submit"
              className="text-btn mr-8"
              type="text"
            >
              Save
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="text"
              disabled={fetchingPageDetails || loading}
              className="text-btn2"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Form.Item>
        </Space>
      </div>
    </Form>
  );
};

export default TemplateSettings;
